import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CursorIcon = function CursorIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CursorIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1.228 1.228a.78.78 0 0 1 .849-.168L14.52 6.244a.778.778 0 0 1-.049 1.455l-4.235 1.438 3.498 3.498a.778.778 0 0 1-1.1 1.1l-3.498-3.498L7.7 14.472a.778.778 0 0 1-1.455.05L1.06 2.076a.78.78 0 0 1 .168-.85m1.994 1.994 3.666 8.8 1.179-3.47a.78.78 0 0 1 .486-.485l3.469-1.179z",
      clipRule: "evenodd"
    })
  }));
};

export { CursorIcon };
